/**
 * Matcha rewards — storefront helpers for the "matcha-bundle-discount" function.
 * Reads the parsed metaobject config (#MatchaRewardsConfig) and exposes `window.MatchaRewards`.
 *
 * Tiers: Matcha set / Mix & Matcha by number of products, Store-wide by cart amount.
 * Free shipping and free gifts are handled by Rebuy — not here.
 */
(() => {
  function readConfig() {
    try {
      const config = JSON.parse(document.getElementById('MatchaRewardsConfig')?.textContent || 'null');
      return config && Array.isArray(config.programs) ? config : null;
    } catch (error) {
      console.warn('[matcha-rewards] Invalid config', error);
      return null;
    }
  }

  const config = readConfig();
  const rate = () => Number(window.Shopify?.currency?.rate) || 1;
  const program = (id) => config?.programs.find((item) => item.id === id) || null;

  /**
   * Highest % reached.
   * @param {string} programId
   * @param {number} amount - number of products for "count" programs, cents (cart currency) for "spend"
   */
  function percentFor(programId, amount) {
    const item = program(programId);
    if (!item || amount <= 0) return 0;
    const factor = item.unit === 'spend' ? 100 * rate() : 1;
    return item.tiers.reduce(
      (best, tier) => (amount >= tier.threshold * factor && tier.value > best ? tier.value : best),
      0
    );
  }

  window.MatchaRewards = { config, rate, program, percentFor };
  document.dispatchEvent(new CustomEvent('matcha-rewards:ready'));
})();
